import React from "react";

import type { ServerDataSuccess } from "./route";

import { Swatch } from "@bared/ui";

export interface SwatchesProps {
  colourVariants: ServerDataSuccess["colourVariants"];
  handle: string;
}

export function Swatches({ colourVariants, handle }: SwatchesProps) {
  return (
    <div className="flex w-full flex-wrap gap-pico">
      {colourVariants.map(({ image, siblingHandle }) => (
        <Swatch
          handle={siblingHandle}
          image={image}
          active={handle === siblingHandle}
        />
      ))}
    </div>
  );
}
